import React from 'react';
import styles from './PaymentMethods.scss';
import language from "@lang/language";

const PaymentMethods = ({data}) => {

	if (!data) {
		return null;
	}

	return (
	  <div className={styles.paymentMethodsHolder}>
		  <div className={styles.paymentMethodsContainer}>
			  {data.firstRow.title && <div dangerouslySetInnerHTML={{__html: data.firstRow.title}}/>}

			  {data.firstRow.content && data.firstRow.content.map((item, key) => {
				  return (
					<div className={styles.holder} key={key}>
						<div className={styles.icon}>
							<img
							  src={item.icon}
							  alt={item.iconAlt}
							  title={item.iconAlt + language.shBGTitle}
							  width={27}
							  height={18}
							/>
						</div>
						<div
						  className={styles.text}
						  dangerouslySetInnerHTML={{__html: item.name}}
						/>
					</div>
				  );
			  })}
		  </div>

		  <div className={styles.paymentMethodsContainer}>
			  {data.secondRow.title && <div dangerouslySetInnerHTML={{__html: data.secondRow.title}}/>}

			  {data.secondRow.content && data.secondRow.content.map((item, key) => {
				  return (
					<div className={styles.holder} key={key}>
						<div className={styles.icon}>
							<img
							  src={item.icon}
							  alt={item.iconAlt}
							  title={item.iconAlt + language.shBGTitle}
							  width={27}
							  height={18}
							/>
						</div>
						<div
						  className={styles.text}
						  dangerouslySetInnerHTML={{__html: item.name}}
						/>
					</div>
				  );
			  })}
		  </div>
	  </div>
	);
}

export default PaymentMethods;
